<template>
<div class="main-wrapper" v-if="pinfo">
  <!--<vue-iframe
    :src="surveyLink"
    frame-id="sframe"
    @load="frameLoad"
    name="sframeName"
    width="100%"
    height="100%"
  />-->
  <iframe id="sframe" width="100%" :src="surveyLink" height="100%" @load="frameLoad" />
  <div class="block-left" id="bleft">
    <div class="section" >
   <nav class="navbar navbar-light navbar-expand-md bg-light topnav">
      <a href="/" class="navbar-brand">
        <img src="/images/Scout_Logo.png" class="img-fluid" alt="logo">
      </a>
      <div class="status-wrap">
        <div style="position: relative;">
          <span class="inter-status">{{ $t('jsur-status') }}</span>
          <span class="intername">{{ pinfo.user.realname }}</span>
          <b-dropdown id="dropdown-1" :text="curStatusTrans" variant="outline-success" class="m-2" size="sm">
            <b-dropdown-item v-for="status in userStatuses" v-if="curStatus!=status" :key="status" @click="setStatus(status)">{{ $t('jsur-st-'+status) }}</b-dropdown-item>
          </b-dropdown>
          <span class="timer" v-if="curStatus!=='online'">{{timer}}</span>
          <a href="#" @click.prevent="doLogout" class="logout-btn">{{ $t('jsur-logout') }} <i class="fa fa-sign-out" aria-hidden="true"></i></a>
        </div>
      </div>
      <div  id="collapsingNavbar3">
          <ul class="nav navbar-nav ml-auto w-100 justify-content-end">
              <li class="nav-item" style="position: relative">
                <span class="projlabel">{{ $t('jsur-curproj') }}</span>
                <input class="cur-proj" type="text" disabled="true" :value="projLabel" />
                <router-link to="/select/change" style="margin-top: -3px;" class="btn btn-outline-success"><i class="fa fa-exchange" aria-hidden="true"></i> {{ $t('jsur-prj-change') }} </router-link>
              </li>
          </ul>
      </div>
  </nav>

  <div class="overlay" v-if="(curStatus !== 'online')||screened"></div>
    <section class="block-center">


    <div class="modal fade" :class="{'in show d-block': extentionProblem }" id="infoModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-slideout" role="document">
        <div class="modal-content">
          <div class="modal-body pt-4 text-center">
            <p class="text-center"  v-if="connectTimer>0">{{ $t('jsur-connect-pbx') }}</p>
            <p v-if="connectTimer<=0" v-html="$t('jsur-connect-pbx-error')"></p>
            <p>{{callConnTime}}</p>
            <a href="#" @click.prevent="doLogout" class="logout-btn">{{ $t('jsur-logout') }} <i class="fa fa-sign-out" aria-hidden="true"></i></a>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade trans" :class="{'in show d-block': isDisconnected }" id="infoModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-slideout" role="document">
        <div class="modal-content">
          <div class="modal-body pt-4 text-center">
            <h3 class="text-center" style="color: #fff">{{ $t('jsur-diconn-title') }}</h3>
            <button v-if="surveyLink" class="btn btn-danger"  @click.prevent="exitSurvey">{{ $t('jsur-exit-survey') }}</button>
            <button v-else class="btn btn-danger"  @click.prevent="diconnectFailed">{{ $t('jsur-btn-failed') }}</button>
            &nbsp;&nbsp;&nbsp;<button class="btn btn-success"  @click.prevent="redialPhone">{{ $t('jsur-redial') }}</button>
            <button class="btn logout-bt" v-if="surveyLink"  @click.prevent="doContinue">{{ $t('jsur-continue') }}</button>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade trans" :class="{'in show d-block': isRedialing }" id="infoModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-slideout" role="document">
        <div class="modal-content">
          <div class="modal-body pt-4 text-center">
            <h3 class="text-center" style="color: #fff">{{ $t('jsur-pbx-dialing') }}</h3>
            <button class="btn btn-danger"  @click.prevent="stopRedial">{{ $t('jsur-pbx-stop-dial') }}</button>
          </div>
        </div>
      </div>
    </div>


      <div class="mt-3 mb-1 pl-5 pr-5" style="position: relative" v-if="pinfo.quest_comments">
              <img src="/images/interw/headset.svg" style="position:absolute;left:8px;top:28px" />
              <p class="triangle-border left" v-html="nlbr(pinfo.quest_comments)"></p>
        </div>

        <div class="mt-3 mb-3 pl-5 pr-5 success-block row" v-if="reason=='success'">
          <div class="col-1">
            <i class="fa fa-check fa-2x"></i>
            <i class="fa fa-thumbs-up fa-2x"></i>
          </div>
          <div class="col-4">
            <h5>{{ $t('jsur-finished') }}</h5>
            <span  class="respinfo">{{ $t('jsur-respid') }}: {{ respId }}</span>
          </div>
          <div class="col-4">
            <span class="respinfo" >{{ $t('jsur-done-intlist') }}</span>
           <select v-model="selResult" class="form-control" >
              <option v-for="(resul) in pinfo.results" v-bind:value="resul.id">
                [{{ resul.id }}] {{ resul.end_time }}
              </option>
            </select>
          </div>
          <div class="col-3">
            <button class="btn btn-next mt-3" @click="toSurveyOpen" :disabled="!hasOpen" >{{ $t('jsur-edit-open') }}</button>
          </div>
        </div>

            <div class="card">
              <h5 class="card-header text-center resp-header">{{ $t('jsur-resp-profile') }}</h5>
              <div class="card-body">
                <div class="row">
                  <div class="col-6 row mb-2" v-if="profile.length"  v-for="prof in profile" >
                    <div class="col-5 resp-label" v-if="prof.name == 'Name' || prof.name == 'name' ">{{ $t('jsur-resp-name') }}</div>
                    <div class="col-5 resp-label" v-else >{{ prof.name }}</div>
                    <div class="col-7 resp-val">{{ prof.value }}</div>
                  </div>
                  <div class="col-12 row mb-2" v-else >No data</div>
                </div>
                <hr>

                <div class="row">
                  <div class="col-2">
                    <div class="phones-title">
                      <span>{{ $t('jsur-phone-nums') }}</span><br>
                      <button class="btn btn-outline-success btn-sm" @click="showManual=true" :disabled="reason=='success'||phoneId"> <i class="fa fa-plus" aria-hidden="true"></i> {{ $t('jsur-btn-manual') }}</button>
                    </div>
                  </div>
                  <div class="col-10">
                    <div class="outer styler-2" >
                      <div class="flex">
                        <div
                          class="phone-item ml-3"
                          :class="phoneStyle(phon)"
                          v-for="phon in phones"
                          v-if="phon.phone"
                          @click="selectPhone(phon.id)" >
                          <div class="pnum">{{ phon.phone }}</div>
                          <div class="pstatus" :class="statusStyle(phon)">{{ statusText(phon) }}</div>
                          <pulse-loader :loading="process=='dial' && phon.id==phoneId" :color="'#6c9e39'" size="11px" ></pulse-loader>
                          <div class="ptimer" v-if="process=='answered' && phon.id==phoneId">{{callTime}}</div>
                          <button v-if="phon.manual && phon.manual==1 && phon.status.type==4" class="btn btn-outline-danger btn-xs" @click="deletePhone(phon.id)">{{ $t('jsur-btn-remove') }}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="panel-heading comment-heding">{{ $t('jsur-comments') }}</div>
       </section>

      <div class="scrollable-content content styler-2 comment-wrapper block-center">
        <ul class="media-list" style="padding: 0 8px 0 0">
            <li v-for="comment in comments">
                <div class="media-body">
                    <span>{{comment.dt}} {{comment.name}}</span>
                    <p>{{comment.value}}
                      <a href="#" class="pull-right" v-if="userId == comment.sender_id" @click.prevent="deleteComment(comment.id)">
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                      </a>
                    </p>
                </div>
            </li>
        </ul>
      </div>

      <div class="d-flex">
        <div class="comm-left">
          <textarea class="form-control" :class="{'readline': emptyComment }" @keydown.enter="createComment" :placeholder="$t('jsur-write-post')" rows="1" v-model="commentText"></textarea>
        </div>
        <div class="comm-right"><button type="button" class="btn btn-info pull-right" @click.prevent="createComment">{{ $t('jsur-btn-post') }}</button></div>
      </div>

      <footer class="bg-dark text-white mt-4 footer-line" :class="{screened: screened}">
          <div class="container-fluid py-3">
              <div class="row">
                  <div class="col-md-2"></div>
                  <div class="col-md-4 btm-phone" v-if="!pbxEnabled && phoneId && reason!='success'">{{ $t('jsur-btn-dealto') }}: {{ curPhoneNum }}</div>

                  <div class="col-md-4" v-if="phoneId && !showStatuses && reason!='success' && !screened">
                    <a href="#" class="btn btn-danger ml-2" v-if="!pbxEnabled||(pbxEnabled && process!='dial')"  @click.prevent="displayStatuses">{{ $t('jsur-btn-failed') }}</a>
                    <a href="#" class="btn btn-danger ml-2" v-if="pbxEnabled && process=='dial'"  @click.prevent="endCall">{{ $t('jsur-pbx-stop-dial') }}</a>
                    <button href="#" class="btn btn-success ml-2" :disabled="pbxEnabled!='0' && process!='answered'" @click.prevent="toSurvey">{{ $t('jsur-btn-tosurvey') }}</button>
                  </div>

                  <!--{{process}}-->

                  <div class="col-md-4" v-if="reason=='success' || screened || curPhoneNum==''">
                    <button class="btn btn-next ml-2" :disabled="process=='stopping' && (reason!='')" @click="nextRespondent">{{ $t('jsur-nextresp') }}</button>
                  </div>

                  <button class="btn btn-danger ml-2" v-if="!isDisconnected && reason=='success' && process=='answered'" @click="endCall(2)">{{ $t('jsur-btn-hangup') }}</button>

                  <div class="col-md-2"></div>
              </div>
          </div>
      </footer>
    </div>
  </div>
  <div class="block-right">
    <div class="section bg-light">
      <div class="sidebar-heading">{{ $t('jsur-updates') }}</div>

      <div class="scrollable-content content ist-group list-group-flush news-list">
        <li class="list-group-item list-group-item-action bg-light" v-for="item in news">
            <span class="badge" :class="'badge-'+item.type">{{ item.type }}</span>
            <span class="news-date">{{ item.dt }}</span><br>
            {{ item.value }}
          </li>
      </div>

    </div>
  </div>

    <div class="modal fade" :class="{'in show d-block': showStatuses }" v-if="curStatus=='online'" id="statusPanel" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-slideout" role="document">
        <div class="modal-content" v-if="!(reason=='zeroquota' || reason=='overquota')">
          <div class="modal-body pt-4">
            <p class="text-center">{{ $t('jsur-phonestat') }}</p>
            <div class="row statlist mt-3">
              <div class="col-3" v-for="stat in condStatuses">
                <div class="for-check form-check">
                  <input class="form-check-input" type="radio" :id="'stat'+stat.id" v-model="statusId" :value="stat.id">
                  <label class="form-check-label":for="'stat'+stat.id">
                    {{stat.name}}
                  </label>
                </div>

                <div v-if="statusId==stat.id && (stat.type==3 || stat.type==4)">
                  <select v-model="nextLng" v-if="stat.type==4" class="form-control">
                    <option v-for="(lng, key) in langs" :value="key" >
                      {{ lng }}
                    </option>
                  </select>
                  <flat-pickr :config="dateTimePicker"
                            id="datetime-input"
                            class="form-control"
                            v-model="nextDt"
                            @on-close="setDate"
                            @on-open="datePikerOpen"
                            placeholder="Next Date">
                  </flat-pickr>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">


            <b-dropdown id="dropdown-2"  v-if="statusId" :text="curStatusTrans" class="pull-right ml-2 break-bt" >
              <b-dropdown-item v-for="status in userStatuses" v-if="curStatus!=status" :key="status" @click="setStatus(status)">{{ $t('jsur-st-'+status) }}</b-dropdown-item>
            </b-dropdown>
             <a href="#" v-if="statusId"  @click.prevent="doLogout" class="btn logout-bt pull-right">{{ $t('jsur-logout') }} <i class="fa fa-sign-out" aria-hidden="true"></i></a>


            <div v-if="reason=='zeroquota' || reason=='overquota'">
              <p>{{ $t('surv-screened') }}</p>
              <br><br>

              <button class="btn btn-next ml-2" :disabled="process=='stopping'"  @click="nextRespondent">{{ $t('jsur-nextresp') }}</button>
            </div>
            <!-- v-if="!statusSceduled && !loppNoStatus.length" -->

            <div v-if="!statusSceduled" >
              |<button class="btn btn-secondary ml-2 manual-bt" :disabled="!statusId" v-if="!finalRemove" @click="showManual=true">{{ $t('jsur-btn-manual') }}</button>
              <button class="btn btn-success ml-2" :disabled="!statusId" v-if="allowNextNumber" @click="setNextPhone()">{{ $t('jsur-btn-nextnumber') }}</button>
            </div>

            <button class="btn btn-next ml-2" :disabled="!statusId || (( (hasUnusedPhones && !statusSceduled) || loppNoStatus.length!==0) && !finalRemove ) " @click="nextRespondent">{{ $t('jsur-nextresp') }}</button>



          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" :class="{'in show d-block': showManual }" id="manualPanel" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-slideout" role="document">
        <div class="modal-content">
          <div class="modal-body pt-4">
            <p class="text-center">Manual dial</p>
            <input class="form-control" type="text" name="" v-model="customPhone" placeholder="Insert phone number" />
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary ml-2"  @click="showManual=false">Cancel</button>
            <button class="btn btn-success ml-2"  @click="addCustomNumber">Add</button>
          </div>
        </div>
      </div>
    </div>


</div>
</template>

<script>

import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import api from '@/api';
import qs from 'qs';


export default {
  name: 'main',
  components: {
    flatPickr, PulseLoader,
  },
  data () {
    return {
      dateTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        time_24hr: true,
        minDate: 'today',
        //defaultDate: curtime,
       // defaultHour: 12,
      },
      lastPbxLogId: 0,
      newPBXStatus: '',
      currentPBXStatus: '',
      callStr: '', // string with all phones of respondent coma separated
      lngs: false,
      sfId: false,
      meId: false,
      phoneId: false,
      statusId: false,
      nextDt: null,
      nextLng: null,
      intermission: 0,
      phonesStatus: {},
      respId: false,
      intervalQuota: 30,
      intervalCallback: 5,
      timerCallback: null,
      finishSurvey: 0,
      finishReason: '',
      successSurvey: 0,
      overqoutaSurvey: 0,
      cancelSurvey: 0,
      process: '',
      pid1: null,
      pid2: null,
      callTimeStart: 0,
      pbxEnabled: 0,
      news: [],
      pinfo: null,
      curStatus: null,
      userStatuses: [
        'online',
        'on-break',
        'in-task'
      ],
      commentText: '',
      emptyComment: false,
      profile: null,
      phones:[],
      comments: [],
      timerInterval: null,
      startDate: null,
      timer: null,
      statuses: [],
      showStatuses: false,
      showManual: false,
      reason: null,
      langs: null,
      customPhone: '',
      userId: null,
      selResult: null,
      hasOpen: false,
      conuts: 0,
      statses_processed: [],
      finalRemove: false,
      timer: null,
      surveyLink: null,
      isDisconnected: false,
      newsInterval: null,
      connectTimer: 60000,
      connectIntval: null,
      isRedialing: false,
    }
  },
  mounted() {

    const storedStatus = localStorage.getItem('callStatus');
    if (storedStatus) {
      this.process = storedStatus;
      this.phoneId = localStorage.getItem('phoneId');
      this.callTimeStart = 0;
      this.startTimer();
    }
    this.reason = this.$route.params.reason;
    this.init();
  },
  computed: {
    curPhoneNum: function () {
      return this.phoneId? this.phones[this.phoneId].phone: '';
    },
    hasNoMsg() {

    },
    curStatusTrans() {
      return this.$t('jsur-st-'+this.curStatus);
    },
    projLabel() {
      return `[${this.pinfo.projId}] ${this.pinfo.projectName}`
    },
    statusSceduled() {
      let stat = this.statuses.find(item=> item.id == this.statusId);
      if(!stat) return false;
      return stat.type==3 || stat.type==4;
    },
    hasUnusedPhones() {
      return Object.values(this.phones).find(phone => phone.status.type == 4 && phone.id != this.phoneId);
    },
    loppNoStatus() {
      return Object.values(this.phones).filter(phone => phone.status.is_return && !this.statses_processed.includes(phone.id)).map(item => item.id);
    },
    allowNextNumber() {
      return (this.hasUnusedPhones || this.loppNoStatus.length) && !this.finalRemove;
    },
    screened() {
      return this.reason=='zeroquota' || this.reason=='overquota'
    },
    extentionProblem() {
      const prob = this.pinfo && parseInt(this.pinfo.auto_deal)
        && (!this.$store.state.userSocketData || this.$store.state.userSocketData.status == 4 || this.$store.state.userSocketData.peerstatus == 'Unregistered')
      return prob;
    },
    callTime() {
      const date = new Date(null);
      date.setSeconds(this.callTimeStart / 1000);
      const utc = date.toUTCString();
      return utc.substr(utc.indexOf(":") - 2, 8);
      /*const secTime = (Date.now() - this.callTimeStart)/1000;
      var date = new Date(0);
      date.setSeconds(secTime);
      var timeString = date.toISOString().substr(11, 8);
      return timeString*/
    },
    callConnTime() {
      const date = new Date(null);
      date.setSeconds(this.connectTimer / 1000);
      const utc = date.toUTCString();
      return utc.substr(utc.indexOf(":") + 1, 6);
    },
    condStatuses() {
      if(this.reason == 'cancel') {
        return this.statuses.filter(item => ['2','3'].includes(item.view));
      } else {
        return this.statuses;
      }
    }
  },
  watch: {
    extentionProblem(prob) {
      if(prob) {
        this.connectTimer = 60000;
        this.startConnTimer();
      } else {
        console.log('ext is fine', this.phones.length);
        console.log(this.phones,this.phoneId, this.pbxEnabled ,this.reason,!this.process)
        if(Object.values(this.phones).length && !this.phoneId && this.pbxEnabled && !this.reason && !this.process) {
          console.log('set next because extension conencted')
          this.setNextPhone();
        }
        this.connectTimer = 60000;
      }
    },
    statusId: function (val) {
      let stat = this.statuses.find(item=> item.id == val);
      if(!stat) return false;
      if(stat.type!=3 && stat.type!=4) {
        this.setPhoneStatus();
      }
    },
    nextLng: function(val) {
      if(this.statusId)
      this.setPhoneStatus();
    },
    selResult: function (val) {
      if(val) {
        this.checkHasOpen();
      }
    },
    "$route.params.reason"(value) {
      this.reason = value;
    },
    "$store.state.lastStatus"(value) {
      if(value.event == 'Hangup') {

        if(value.uniqueid == this.pid1) {
          this.pid1 = null;
        }
        if(value.uniqueid == this.pid2) {
          this.pid2 = null;
        }

        console.log('Hangup',this.process);
        clearInterval(this.timer);
        this.isRedialing = false;
        if(this.showStatuses) {
          return false;
        }
        if( !['success', 'zeroquota', 'overquota'].includes(this.reason) && !this.showStatuses ) {
          if(this.process=='stopped'||this.process=='stopping')  {
            console.log('stopping because process = ', this.process);
            this.showStatuses = true;
          } else if(this.process!='')  {
            console.log(':::: show dicon on hangup for process', this.process)
            if(!value.channel.match(/Local/)){
              console.log('channel not local');
              this.isDisconnected = true;
            }
          } else {
          }
        } else {
          this.setProcess('');
        }
      }
      if(value.event == "Bridge" && value.bridgestate == "Link" && value.uniqueid1 == this.pid1) {
        this.setProcess('answered');
        this.isRedialing = false;
        this.callTimeStart = 0;
        this.startTimer();
      }
      if(value.event == "ExtensionStatus") {
        this.$store.commit('UPDATE_EXT_STATUS', value.status);
      }
      //console.log('watch value', value);
    }
  },
  beforeDestroy() {
    console.log('bedore destroy');
    clearInterval(this.newsInterval);
    clearInterval(this.connectIntval);
    this.resetTimer();
  },
  methods: {
    setProcess(val) {
      this.process = val;
      localStorage.setItem('callStatus', val);
      localStorage.setItem('phoneId', this.phoneId);
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.callTimeStart += 1000;
      }, 1000);
    },
    resetTimer() {
      clearInterval(this.timer);
      this.callTimeStart = 0;
    },
    startConnTimer() {
      this.connectIntval = setInterval(() => {
        this.connectTimer -= 1000;
        if(this.connectTimer < 0) {
          this.connectTimer = 0;
          clearInterval(this.connectIntval);
        }
      }, 1000);
    },
    resetConnTimer() {
      clearInterval(this.connectIntval);
      this.callTimeStart = 60000;
    },
    async init() {
      if(this.screened) {
        //$loadNext = false;
        notie.alert({ type: 'error', text: this.$t('surv-screened') });
      }
      await this.fetchData();
      await this.loadNextRespondent(true);
      await this.loadNews();
      this.curStatus = this.userStatuses[0];
      this.newsInterval = setInterval( () => { this.loadNews(); }, 6*1000);
    },
    async fetchData() {
      try{
        let finished = this.reason? `/finish/1/reason/${this.reason}`:'';
        let result = await api.get(`/survey/interviewer/index${finished}?spa=1`);
        this.pinfo = result.data;
        this.pbxEnabled = parseInt(this.pinfo.auto_deal);
        if(result.data.respId) {
          this.respId = result.data.respId;
          this.sfId = result.data.sfId;
        }
        if(result.data.results && result.data.results.length) {
          this.selResult = result.data.results[0].id;
        }
        this.userId = parseInt(result.data.user.id)
      } catch(err) {
        if(err.response.status == 401){
          this.doLogout();
        }
      }
      // console.log(result.data);
      /*if(result.data.success) {
        this.projects = result.data.projects;
        this.selProj = Object.keys(this.projects)[0];
      }*/
    },
    async loadNews() {
      const params = { respId: this.respId }
      const res = await api.get('/survey/interviewer/get-interactive-news', { params });
      this.news = [];
      if(res.data.data) {
        if(res.data.data.quotas) {
          res.data.data.quotas = Object.values(res.data.data.quotas);
        }
        res.data.data.quotas.forEach(item => {
          item.type = 'quota';
          try{
            let qvals = JSON.parse(item.value);
            const qstatus = {
              '0': 'Closed',
              '1': 'Open'
            };

            item.value = qvals.qname+' - '+qvals.qcontent + ': '+ qstatus[qvals.qstatus];
            this.news.push(item);
          } catch(err) {

          }
        });
        res.data.data.messages.forEach(item => {
          item.type = 'general';
          this.news.push(item);
        });
      }
    },
    async doLogout() {
      localStorage.removeItem('user');
      this.$store.commit('LOGOUT_USER');
      this.$socket.client.close();
      //if(this.process=='dial' || this.process=='answered') {
        this.endCall();
      //}
      let result = await api.get('/auth/index/logout');
      this.$router.push('/');
    },
    async setStatus(type) {
      this.curStatus = type;
      this.timeStatus = 0;
      let inter = 0;
      let itype = 0;
      clearInterval(this.timerInterval);
      if(type != 'online') {
        this.startDate = new Date();
        this.timerInterval = setInterval( () => {
          this.timer = new Date(new Date().getTime() - this.startDate.getTime()).toISOString().substr(11, 8)
        }, 1000);
        inter = 1;
        itype = (type == 'on-break')? 1: 2;

        if(this.pbxEnabled) {
          console.log('end call set status');
          this.endCall(1);
          this.reason='';
        }
      }
      await api.get(`/survey/interviewer/set-intermission?intermission=${inter}&isubtype=${itype}`);
    },
    async generalInfo() {
      let res = await api.get('/survey/interviewer/get-general-info');
      if(this.reason == 'cancel') {
        this.statuses = res.data.data.statuses.filter(item => ['2','3'].includes(item.view));
      } else {
        this.statuses = res.data.data.statuses;
      }
      if(res.data.data.lngs) {
        this.langs = res.data.data.lngs;
        this.nextLng = Object.keys(this.langs)[0];
      }
    },
    async loadNextRespondent(init=false, hideStatus=true, manual=false) {
      console.log('nest respondednt add manual', manual);
      let link = `/survey/interviewer/get-next-respondent?respId=${this.respId}`
      if(this.reason && this.respId && init) {
        link = `/survey/interviewer/get-respondent-info?respId=${this.respId}&sfId=${this.sfId}`;
      } else {
        //this.$router.push('/main');
      }
      let res = await api.post(link);
      res = res.data;
      const self = this;
      if( res.code == 0 && res.data ) {
        this.statses_processed = [];
        self.generalInfo();
        // сбрасываем состояние окончания опроса!
        self.finishSurvey = 0;
        self.successSurvey = 0;
        self.cancelSurvey = 0;
        self.overqoutaSurvey = 0;

        this.respId = 0;
        this.sfId = 0;

        this.nextDt = null;
        this.statusId = null;
        if (res.data.sfId) {
          this.sfId = parseInt(res.data.sfId);
        }
        if (res.data.respId) {
          this.respId = parseInt(res.data.respId);
          this.loadComments();
        }
        this.profile = res.data.profile;
        if (res.data.profile) {
          //self.createProfile(res.data.profile);
        }
        this.phones = res.data.phones;
        const inUse = Object.values(this.phones).find(phone => phone.status.type === 2);

        if(this.process!='answered') {
          this.setProcess('');
          this.phoneId = null;
          if(inUse) {
              this.phoneId = inUse.id;
              if(this.pbxEnabled) {
                this.prepareCall(this.phoneId);
              }
            }
        }


        if(init) {
          this.showStatuses = this.reason && !['success', 'overquota', 'zeroquota'].includes(this.reason)? true: false;
        } else {
          this.showStatuses = false;
          this.$router.push('/main');
        }
        console.log('resp load',  this.pbxEnabled, 'reas'+this.reason+'ext'+this.extentionProblem+'proces'+this.process );
        if(!inUse && this.pbxEnabled && !this.reason && !this.extentionProblem && !this.process ) {
          console.log('set next freom next respondednt methd')

          if(manual) {
            const manNum = Object.values(this.phones).find(phone => phone.phone == manual.replace(/^0+/, ''));
            console.log('calling manual', manNum);
            this.selectPhone(manNum.id);
          } else {
            this.setNextPhone();
          }
        }
        if( res.data.callStr ){
          this.callStr = res.data.callStr;
        }
      } else if(res.code == 3) {
          if(this.conuts > 3) {
            this.$router.push('/select/completed?pid='+this.pinfo.projId);
          }
          this.loadNextRespondent();
          this.conuts++;
      } else if(res.code == 4 || res.code == 2) {
        this.$router.push('/select/completed?pid='+this.pinfo.projId);
      } else {
        notie.alert({ type: 'error', text: res.message });
        this.$router.push('/select');
      }
    },
    async loadComments() {
      const res = await api.post('/survey/interviewer/get-comments', qs.stringify({respId: this.respId}) );
      this.comments = res.data.data;
    },
    async deleteComment(id) {
      const res = await api.post(`/survey/interviewer/delete-comment/?commentId=${id}`);
      this.loadComments();
    },
    async createComment(text, comId) {
      text = this.commentText && this.commentText !== "\n"? this.commentText.trim(): null;
      if(!text) {
        this.emptyComment = true;
        setTimeout(() => { this.emptyComment = false }, 3000);
        this.commentText = null;
        setTimeout(() => { this.commentText = null }, 50);
        return false;
      }
      const data = {
        respId: this.respId,
        //comId: comId,
        text: text
      };
      setTimeout(() => { this.commentText = null }, 50);
      this.commentText = null;
      const res = await api.post('/survey/interviewer/save-comment', qs.stringify(data) );
      this.loadComments();
    },
    async setPhoneStatus() {
      var data = {};
      if( this.phoneId ){
        data['phoneId'] = this.phoneId;
      }
      if( this.statusId ){
        data['statusId'] = this.statusId;
      }
      if( this.nextDt ){
        if(new Date(this.nextDt) < new Date()) {
          //this.$set(this.dateTimePicker, 'defaultDate', new Date());
          let now = new Date();
          this.nextDt = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 19).replace('T', ' ');
        }
        data['nextDt'] = this.nextDt;
      }
      if( this.nextLng ){
        data['nextLng'] = this.nextLng;
      }
      const res = await api.post('/survey/interviewer/set-phone-status', qs.stringify(data) );
      if(res.data.code == 0) {
        this.statses_processed.push(this.phoneId);
        //console.log(this.loppNoStatus);
        let curStat = this.statuses.find(item => item.id == this.statusId);
        //console.log(curStat);
        this.phones[this.phoneId].status.id = this.statusId;
        this.phones[this.phoneId].status.name = curStat.name;
        this.phones[this.phoneId].status.type = curStat.type;
        this.finalRemove = (curStat.type == 5 || curStat == 3) ? true: false;
        this.phones[this.phoneId].status.label = this.$t('jsur-btn-failed');//'Failed';
      } else {
        notie.alert({ type: 'error', text: _t('jint-phone-status-error') });
      }
      this.setProcess('');
    },
    async addCustomNumber() {
      if(this.pbxEnabled) {
          console.log('end call custom number');
          await this.endCall(1);
          this.reason='';
      }
      const res = await api.post('/survey/interviewer/custom-phone', qs.stringify({num: this.customPhone, sfid: this.sfId }) );
      if(res.data.code == 0) {
        this.loadNextRespondent(false, false, this.customPhone);
        this.customPhone = '';
        this.showManual = false;
      }
    },
    async deletePhone(id) {
      const res = await api.post(`/survey/interviewer/delete-phone/?phoneId=${id}`);
      this.loadNextRespondent();
    },
    toSurvey() {
      if(this.finishSurvey == 1 && this.finishReason=="overquota") {
        notie.error(_t('jint-overquota-not-survey'));
      } else {
        this.surveyLink = '/survey/interviewer/to-survey/?respId=' + this.respId + '&sfId=' + this.sfId+'&phoneId='+this.phoneId;
        const iframe = document.getElementById('sframe');
        iframe.style.display = 'block';

        function iframeURLChange(iframe, callback) {
          var lastDispatched = null;

          var dispatchChange = function () {
              var newHref = iframe.contentWindow.location.href;

              if (newHref !== lastDispatched) {
                  callback(newHref);
                  lastDispatched = newHref;
              }
          };

          var unloadHandler = function () {
              // Timeout needed because the URL changes immediately after
              // the `unload` event is dispatched.
              setTimeout(dispatchChange, 0);
          };

          function attachUnload() {
              // Remove the unloadHandler in case it was already attached.
              // Otherwise, there will be two handlers, which is unnecessary.
              iframe.contentWindow.removeEventListener("unload", unloadHandler);
              iframe.contentWindow.addEventListener("unload", unloadHandler);
          }

          iframe.addEventListener("load", function () {
              attachUnload();

              // Just in case the change wasn't dispatched during the unload event...
              dispatchChange();
          });

          attachUnload();
      }

      // Usage:
      iframeURLChange(document.getElementById("sframe"), async (newURL) => {
          console.log("URL changed:", newURL);
           if (newURL.match('main')) {
              console.log('returned from survey');
              this.reason = newURL.split('/').pop();
              if ( this.reason == 'cancel') {
                /*if(this.pbxEnabled) {
                  await this.endCall(1);
                } else {*/
                  this.showStatuses = true;
                //}
              }
              if(this.screened) {
                notie.alert({ type: 'error', text: this.$t('surv-screened') });
              }
              this.surveyLink = null;
              iframe.style.display = 'none';

              /*iframe.contentWindow.document.open();
              iframe.contentWindow.document.write('');
              iframe.contentWindow.document.close();*/


              await this.fetchData();

              const link = `/survey/interviewer/get-respondent-info?respId=${this.respId}&sfId=${this.sfId}`;
              let res = await api.post(link);
              res = res.data;
              if( res.code == 0 && res.data ) {
                this.phones = res.data.phones;
              }
           }
      });


        //window.location.href = '/survey/interviewer/to-survey/?respId=' + this.respId + '&sfId=' + this.sfId+'&phoneId='+this.phoneId;
      }
    },
    toSurveyOpen() {
      window.location.href = '/survey/interviewer/to-survey-open/?actId=' + this.selResult;
    },
    async frameLoad() {
      console.log('frameLoad', iframe.contentWindow.location.href);
      const iframe = document.getElementById('sframe');
      const frameUrl = iframe.contentWindow.location.href;
      console.log('return frameurl', frameUrl);
      if (frameUrl.match('interviewer')) {
        console.log('returned from survey');
        this.reason = frameUrl.split('/').pop();
        if (this.pbxEnabled && this.reason == 'cancel') {
          //await this.endCall(1);
        }
        if(this.screened) {
          notie.alert({ type: 'error', text: this.$t('surv-screened') });
        }
        this.surveyLink = null;
        iframe.style.display = 'none';

        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write('');
        iframe.contentWindow.document.close();


        await this.fetchData();

        const link = `/survey/interviewer/get-respondent-info?respId=${this.respId}&sfId=${this.sfId}`;
        let res = await api.post(link);
        res = res.data;
        if( res.code == 0 && res.data ) {
          this.phones = res.data.phones;
        }
      }
    },
    async nextRespondent() {
      const res = await api.get(`/survey/interviewer/check-allow-next-respondent?sfId=${this.sfId}`);
      if(res.data.code==0 ){
        if(!this.reason || this.reason == 'cancel') {
          await api.get(`/survey/interviewer/set-respondent-status?respId=${this.respId}`);
        }
        if(this.pbxEnabled) {
          console.log('end call next respondent');
          await this.endCall(1);
          this.reason='';
        }
        this.reason='';
        this.loadNextRespondent();
      } else {
        notie.alert({ type: 'error', text: _t('jint-set-phone-status') });
      }
    },
    async selectPhone(phonId=null) {
      console.log('selecting phone');
      if(this.phoneId == phonId || this.reason=='success' ) {
        return false;
      }
      console.log('selecting phone next');
      let allow = await this.checkNextphone();
      if(!allow) {
        notie.alert({ type: 'error', text: _t('jint-current-phone-nostatus') });
        return false;
      }

      if(this.pbxEnabled ) {
        console.log('before starting call process ', this.process);
        if(this.process == '' || this.process == 'failed') {
          this.prepareCall(phonId);
        }
      } else {
        const res = await api.post('/survey/interviewer/call-phone', qs.stringify({ phoneId: phonId }));
        //}
        this.phoneId = phonId;
        this.showStatuses = false;
        this.statusId = null;
      }
    },

    async asyncInterval(callback, ms, triesLeft = 1) {
      return new Promise((resolve, reject) => {
        const interval = setInterval(async () => {
          if (callback()) {
            resolve();
            clearInterval(interval);
          } else if (triesLeft <= 1) {
            reject();
            clearInterval(interval);
          }
          triesLeft--;
        }, ms);
      });
    },

    hasPids() {
      return !(this.pid1 && this.pid2);
    },

    prepareCall(phoneId) {
      console.log('dial phone');

      this.phoneId = phoneId;
      this.setProcess('dial');
      const curPhone = Object.values(this.phones).find(phone => phone.id == this.phoneId);
      this.callStr = curPhone.phone;
      this.$store.commit('CLEAR_STATUSES');
      this.pid1=null;
      this.pid2=null;
      this.callRequest();
    },
    async setNextPhone() {
      console.log('set next phone');
      if(this.pbxEnabled) {
        //if(this.pid) {
          console.log('end call set next phone');
            await this.endCall(1);
        //}
      }
      if(!this.hasUnusedPhones && !this.loppNoStatus.length) {
        if(this.pbxEnabled) {
          const phons = Object.values(this.phones);
          this.showStatuses = false;
          this.statusId = null;
          console.log('selcting pbx phone', phons[0].id);
          this.selectPhone(phons[0].id);
        } else {
          notie.alert({ type: 'error', text: 'No phones left' });
          return false;
        }
      } else {
        const leftPhones = Object.values(this.phones).filter(phone => phone.status.type == 4 && phone.id != this.phoneId);
        if(this.loppNoStatus.length) {
          this.showStatuses = false;
          this.statusId = null;
          this.selectPhone(this.loppNoStatus[0]);
          return true;
        }

        if(leftPhones.length > 1) { console.log('has phones');
          this.phoneId = null;
          this.showStatuses = false;
          this.statusId = null;
          if(this.pbxEnabled) {
            this.selectPhone(this.hasUnusedPhones.id);
          }
        } else {
          if(this.pbxEnabled) {
            this.showStatuses = false;
            this.statusId = null;
          }
          this.selectPhone(this.hasUnusedPhones.id);
        }
      }
    },
    async checkNextphone() {
      if(!this.phoneId) {
        return true;
      }
      const res = await api.post('/survey/interviewer/check-complete-phone', qs.stringify({phoneId: this.phoneId}));
      return res.data.code == 0
    },
    async checkHasOpen(id) {
      this.hasOpen = false;
      const res = await api.post(`/survey/interviewer/count-open/?id=${this.selResult}`);
      if(parseInt(res.data.cnt) > 0) {
        this.hasOpen = true;
      }
    },
    statusText(phon) {


      const defStatus = this.pbxEnabled? 'Ready': this.$t('jsur-click-dial');
      let label = this.phoneId? '': defStatus;
      if(phon.status.type==3) {
        label = this.$t('status-SUCCESS');
        console.log('phone is success', label);
      }
      if(phon.status.name) {
        label = phon.status.label === 'Success'? this.$t('status-SUCCESS'): phon.status.label +' '+phon.status.name;
        //console.log('sucess 2',phon )
      }
      if( (phon.status.type == 2 && this.phoneId == phon.id) || (this.phoneId == phon.id && phon.status.type==4)) {
        label = (this.reason && this.reason!=='success')? this.$t('jsur-btn-failed'): this.$t('jsur-dial-num');
        if(this.process=='dial') {
          label = 'Dialing';
        } else if(this.process=='answered') {
          label = 'Answered';
        }
      }
      return label;
    },
    phoneStyle(phon) {
      let failed = phon.status.type == 1? true: false;
      if(phon.status.type == 2 && this.phoneId != phon.id && this.reason!='success') {
        failed = true;
      }
      return {
        active: this.phoneId == phon.id || phon.status.type==3,
        manual: phon.manual==1,
        gray: this.phoneId && this.phoneId != phon.id || this.reason == 'success',

      }
    },
    statusStyle(phon) {
      /*let label = '';
      if(phon.status.type==3) {
        label = 'success';
      }
      if(this.phoneId == phon.id) {
        label = 'dial';
      }
      if(phon.status.type == 1) {
        label = 'failed';
      }
      if(phon.status.type == 2 && this.phoneId != phon.id) {
        label = (this.reason && this.reason=='success')? 'dial': 'failed';
      }*/
      //return label;
    },
    setDate() {
      this.setPhoneStatus();
    },
    datePikerOpen() {
      //this.nextDt = curtime;
      //this.dateTimePicker.defaultHour = 5;
    },
    displayStatuses() {
      let curtime = new Date();
      curtime.setMinutes(curtime.getMinutes()+5);
      this.$set(this.dateTimePicker, 'defaultDate', curtime);
      this.showStatuses=true;
    },
    nlbr: function (value) {
      if (!value) return ''
      return value.replace(/(?:\r\n|\r|\n)/g, '<br>');
    },
    async callRequest() {
      this.setProcess('dial');
      //const phone = this.phones.find
      const res = await api.get(`/api/pbx/make-call`, { params: {"number":this.callStr,"manual":0,"phone_id": this.phoneId, "sf_id":this.sfId}});
      if(res.data.data.Response == 'fail') {
        if(!this.isDisconnected && this.process!=='dial'){
          console.log('showing statuse because call request failed')
          this.showStatuses = true;
        }
        this.setProcess('failed');
      } else {
        this.pid1 = res.data.data.Uniqueid1;
        this.pid2 = res.data.data.Uniqueid2;
      }
      //console.log(res.data);
    },
    async endCall(silent=false) {
      this.process = 'stopping';
      if(silent && silent===2) {
        this.setProcess('');
      }
      const res = await api.get(`/api/pbx/hangup`, { params: {"number":this.callStr,"manual":0,"phone_id": this.phoneId, "sf_id":this.sfId}});
      console.log('before hangup');
      if(!silent) {
        await this.asyncInterval(this.hasPids, 500);
      }
      console.log('after pids hangup');
      if(silent) {
        this.setProcess('');
      } else {
        this.setProcess('stopped');
      }
      this.resetTimer();
      if(silent!==2) {
        console.log('DO SHOW STATUSES1');
        this.showStatuses = true;
      }
    },
    async stopRedial() {
      await this.endCall();
      this.exitSurvey();
    },
    async exitSurvey() {
      this.isRedialing = false;
      this.isDisconnected = false;
      this.reason = 'cancel';
      this.surveyLink = null;
      const iframe = document.getElementById('sframe');
      iframe.style.display = 'none';
      /*iframe.contentWindow.document.open();
      iframe.contentWindow.document.write('');
      iframe.contentWindow.document.close();*/

      this.showStatuses = true;
    },
    async diconnectFailed() {
      this.isDisconnected = false;
      this.showStatuses = true;
    },
    doContinue() {
      this.setProcess('');
      this.isDisconnected=false;
    },
    async redialPhone() {
      this.isDisconnected = false;
      if(this.surveyLink) {
        this.isRedialing = true;
      }
      this.callRequest();
    },
    /*getLastPbxLog: function(self) {
        if(console) {
            console.log('get last status');
        }
        $.ajax({
            url : '/api/pbx/get-current-status',
            data:{"lastId":self.lastPbxLogId},
            success: function ( res ){
                if(typeof(res) === 'string' && res.trim() != '' ){
                    res = JSON.parse(res);
                }
                if(console) {
                    console.log('Loaded statuses');
                    console.log(res);
                }
                if(res.code == 0) {
                    //Log records loaded OK, need to proceed logs one by one
                    if(res.data && res.data.length>0) {
                        var rows = res.data;
                        for(var i=0;i<rows.length;i++) {
                            var row = rows[i];
                            if(console) {
                                console.log('Row');
                                console.log(row);
                            }
                            self.lastPbxLogId = row.id;
                            self.newPBXStatus = row.status;
                            self.handlingPbxStatusUpdate(self,row);
                            if(row.final_dial=="1") {
                                console.log('final_dial');
                                clearInterval(self.timerCallback);
                                self.setRespondentStatusStop(self);
                                self.loadNextRespondent();
                            }
                        }
                    }
                } else {
                    alertify.error(res.message);
                    clearInterval(self.timerCallback);
                }
            }
        });
    },*/
  },
  filters: {

  },
  sockets: {
    connect() {
      console.log('socket connected')
    },
    connection_authentication(data) {
      //this.$socket.emit('connection_authentication', "varun", "123456", 'midgam.voip');
      console.log('>>>>>>>connection_authentication');
    },
    connection_initialized(data) {
      console.log('connection_initialized');
    },
    BLB_event(data) {

    }
  },
}
</script>
<style>
  iframe{
      overflow:hidden;
  }
  #sframe{
     z-index: 1000;
     position: absolute;
     display: none;
  }
  .screened{
    z-index: 1000;
  }
  .trans .modal-content{
    background: none;
    border: none;
  }

</style>
